import React from "react";
import HeaderMain from "../../components/HeaderMain";

const HeaderAll = () => {
  return <HeaderMain />;
};

export default HeaderAll;
